import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=2b6cf9ce&scoped=true&"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=2b6cf9ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6cf9ce",
  null
  
)

export default component.exports